var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpanishFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 44.800003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.35388,-.3433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.35388 33.943h70v11.2h-70z",
    fill: "#c60b1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.35388 11.543h70v22.4h-70z",
    fill: "#ffc400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.35388.3433h70v11.2h-70z",
    fill: "#c60b1e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanishFlag);
export default __webpack_public_path__ + "static/media/spanish-flag.f8773eac5989d78ac448c1737a5d12ea.svg";
export { ForwardRef as ReactComponent };